import axios from 'axios';
import { createActionType } from 'utils/redux';
import { apiGetConfig } from 'constants/apiRouting';
import { handleErrors } from '../../utils/api';

export const GET_CONFIG = createActionType('GET_CONFIG');

export const getConfig = () => async (dispatch) => {
  dispatch({
    type: GET_CONFIG.name,
    payload: axios.get(
      apiGetConfig(),
      { withCredentials: true },
    ).catch(error => handleErrors(error, dispatch)),
  });
};
